"use client";

import React from "react";
import Link from "next/link";
import { track } from "@lib/track";

const FooterText = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="text-center text-xs">
      <p className="text-[var(--color-text-brand)] mr-2">© {currentYear} CF Organic Wellness</p>
      <p className="text-[var(--color-text-brand)] mr-2">
        Redefined by
        <a
          href="https://www.yewly.co.uk"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[var(--text-brand)] font-black hover:underline mx-1"
          onClick={() => track("click", { label: "Footer > Yewly", component: "FooterText" }, { event: "click", label: "Footer > Yewly", component: "FooterText" })}
        >
          Yewly
        </a>
        – Smarter Work. Healthier Teams. Stronger Futures.
      </p>

      <div className="text-center mb-2">
        <p className="text-[var(--color-text-brand)] mr-2">
          <Link
            href="/privacypolicy"
            className="text-[var(--text-brand)] hover:underline mx-4"
            onClick={() => track("click", { label: "Footer > Privacy Policy", component: "FooterText" }, { event: "click", label: "Footer > Privacy Policy", component: "FooterText" })}
          >
            Privacy Policy
          </Link>
        </p>
      </div>
    </div>
  );
};

export default FooterText;